export default __webpack_public_path__ + "static/media/p1.f11f2e3a.png";